import { render, staticRenderFns } from "./home_group.vue?vue&type=template&id=212238b0&scoped=true"
import script from "./home_group.vue?vue&type=script&lang=js"
export * from "./home_group.vue?vue&type=script&lang=js"
import style0 from "./home_group.vue?vue&type=style&index=0&id=212238b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212238b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212238b0')) {
      api.createRecord('212238b0', component.options)
    } else {
      api.reload('212238b0', component.options)
    }
    module.hot.accept("./home_group.vue?vue&type=template&id=212238b0&scoped=true", function () {
      api.rerender('212238b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_group.vue"
export default component.exports